import { Button, EmptyState } from "@thekrystalship/krystal";
import { AuthShell } from "./AuthChrome.jsx";

// BootFailed — signed in, and the first paint could not be settled.
//
// The boot cover waits only on questions somebody is answering; when one of them comes back with an
// answer the shell cannot be drawn from, this is what is shown instead, and it always offers a way
// forward. Try again reloads, which re-asks every question from the start; Sign out ends the session
// at the provider.
//
//   refused        every node answered `GET /hosts` with a refusal or an error
//   timeout        the boot deadline passed with a question still unanswered

const WHAT = {
  refused: {
    icon: "shield-x",
    title: "Couldn’t load your nodes",
    body: (c) => (c.error ? <>{c.error}</> : <>Every node refused the request.</>),
  },
  timeout: {
    icon: "clock",
    title: "Still waiting on the cluster",
    body: () => <>The cluster didn’t answer in time.</>,
  },
};

function BootFailed({ reason, onRetry, onSignOut }) {
  const what = WHAT[reason.kind] || WHAT.timeout;
  return (
    <AuthShell tagline="Sign in to your control panel.">
      <EmptyState icon={what.icon} title={what.title} tone="warn"
        actions={(
          <>
            <Button variant="primary" size="xl" wide onClick={onRetry}>Try again</Button>
            <Button size="xl" wide icon="log-out" onClick={onSignOut}>Sign out</Button>
          </>
        )}>
        {what.body(reason)}
      </EmptyState>
    </AuthShell>
  );
}

export { BootFailed };
